import img1 from "../images/unnamed/Screenshot_24.png";
import img2 from "../images/unnamed/Screenshot_25.png";
import img3 from "../images/unnamed/Screenshot_49.png";
import img4 from "../images/unnamed/Screenshot_50.png";
import img5 from "../images/unnamed/Screenshot_51.png";
import img6 from "../images/unnamed/Screenshot_52.png";
import img7 from "../images/unnamed/Screenshot_53.png";
import img8 from "../images/unnamed/Screenshot_54.png";

export const imgUnnamed = [
  {
    id: 104101,
    image: img1
  },
  {
    id: 104102,
    image: img2
  },
  {
    id: 104103,
    image: img3
  },
  {
    id: 104104,
    image: img4
  },
  {
    id: 104105,
    image: img5
  },
  {
    id: 104106,
    image: img6
  },
  {
    id: 104107,
    image: img7
  },
  {
    id: 104108,
    image: img8
  },
  
];